<template>

<div class="modal-wrapper" :class="{'is-profile': isProfile, 'is-large': isLarge, 'is-standalone': $route.meta.isStandalone}">

	<div class="modal-loading" v-if="loading && loadingText" v-html="loadingText" />
	<div class="modal-loading is-icon" v-if="loading && !loadingText"><i class="fa fa-spin fa-spinner"></i></div>
	
	<div class="modal-close" v-tooltip="'Close'" :class="{'is-overlaid': noheader}" v-on:click.stop="onClose"><i class="fa" :class="{[iconClass]: true}"></i></div>

	<div class="modal" v-show="!loading" v-bind:class="{[typeClass]: true}" v-on:touchstart.stop="onStop">

		<core-modal-head :game="game" v-if="!noheader">
			<slot name="head"></slot>
		</core-modal-head>

		<slot name="sticky"></slot>

		<core-modal-body v-if="!isEmpty" :nopadding="nopadding" :initialScroll="initialScroll" :trackScroll="trackScroll" v-on:scroll="$emit('scroll', $event)" :type="type" :nofoot="hideFoot">
			<div class="body-inner" :class="{'no-padding': nopadding}">
				<slot></slot>
			</div>
		</core-modal-body>

		<core-modal-emptybody v-if="isEmpty" :nopadding="nopadding" :initialScroll="initialScroll" :trackScroll="trackScroll" v-on:scroll="$emit('scroll', $event)" :type="type" :nofoot="hideFoot">
			<slot></slot>
		</core-modal-emptybody>

		<core-modal-foot align="center" v-if="!hideFoot">
			<slot name="foot"></slot>
		</core-modal-foot>
		
	</div>

</div>

</template>

<script>

export default {

	props: ['type', 'hideFoot', 'nopadding', 'initialScroll', 'isEmpty', 'trackScroll', 'isLarge',  'loading', 'icon', 'noheader', 'loadingText', 'game'],

	created: function() {

		if (!this.isLarge) this.$pubsub.$emit('panel.opened')

	},

	beforeDestroy: function() {

		if (!this.isLarge) this.$pubsub.$emit('close.modal')

	},

	computed: {

		iconClass: function() {

			return ((this.icon || this.window.is.menu) && !this.window.is.mobile) ? 'fa-caret-left' : 'fa-times'

		},

		typeClass: function() {

			if (this.type === 'confirm') return 'type-confirm'

			return 'type-default'

		},

		canClose: function() {

			return this.type !== 'confirm'

		}

	},

	methods: {

		onClose: function() {

			this.$emit('close')

		},

		onStop: function() {}

	}

}

</script>

<style scoped>

.modal-wrapper {
	position: fixed;
	top: 0px;
	width: 320px;
	height: calc(100vh - var(--vh-offset, 0px));
	right: 0px;
	bottom: 0px;
	background-color: #2b5870;
	z-index: 5000;
}

.modal-wrapper.is-large {
	background-color: #fff;
    width: 800px;
    box-shadow: 0 7px 29px 0 rgba(100, 100, 111, .2);
	z-index: 10001;
}

.modal-wrapper:not(.is-large).is-profile {
	top: 64px;
}

.is-mobile .modal-wrapper:not(.is-large).is-profile {
	top: 48px;
}

.is-mobile .modal-wrapper {
	width: 100%;
	right: 0px;
	top: 48px;
	height: calc(100vh - var(--vh-offset, 0px) - 48px);
}

@media (max-width: 1000px) {

	.modal-wrapper.is-large {
		width: 100%;
	}

}

.is-mobile .modal-wrapper.is-standalone {
	top: 0px;
}

.modal-loading {
	color: #fff;
	font-size: 14px;
	line-height: 18px;
	text-align: center;
	font-weight: 300;
	position: absolute;
	top: 50%;
	padding: 20px 15px 15px 15px;
	transform: translateY(-50%);
}

.modal-wrapper.is-large .modal-loading {
	color: #4881bb;
}

.modal-loading.is-icon {
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 32px;
	color: #fff;
}

.modal {
	display: flex;
	flex-direction: column;
	align-content: center;
	background-color: #2b5870;
	width: 100%;
	height: calc(100vh - var(--vh-offset, 0px) - 64px);
	flex-basis: 0;
}

.modal-wrapper.is-large .modal {
	background-color: #fff;
	height: calc(100vh - var(--vh-offset, 0px));
}

.modal-wrapper.is-profile:not(.is-large) .modal {
	height: calc(100vh - var(--vh-offset, 0px) - 64px);
}

.is-mobile .modal {
	height: calc(100vh - var(--vh-offset, 0px) - 48px)!important;
}

.is-mobile .modal-wrapper.is-standalone .modal {
	height: calc(100vh - var(--vh-offset, 0px));
}

.modal.type-confirm .modal-dialog {
	text-align: center;
}

.modal-close {
	position: absolute;
	right: 20px;
	top: 24px;
	height: 40px;
	width: 40px;
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.25);
	color: #fff;
	line-height: 40px;
	font-size: 20px;
	text-align: center;
	cursor: pointer;
	z-index: 3;
}

.is-smaller .modal-close {
	top: 12px;
}

.is-mobile .modal-close {
	right: 10px;
	height: 32px;
	width: 32px;
	top: 8px;
	line-height: 32px;
	font-size: 16px;
}

.modal-close.is-overlaid {
    background-color: #19455c;
}

.is-desktop .modal-close:hover {
	background-color: rgba(0, 0, 0, 0.5);
}

.is-desktop .modal-close.is-overlaid:hover {
    background-color: #0E232E;
}

.is-mobile .body-inner:not(.no-padding) {
	padding: 10px;
}

</style>